import { Section } from "@/components/layout/Section";
import { Container } from "@/components/layout/Container";
import { AppShowcase, type AppShowcaseProps } from "./AppShowcase";

interface ShowcaseSectionProps {
  apps: Array<
    Omit<AppShowcaseProps, "variant"> & {
      id: string;
    }
  >;
}

export function ShowcaseSection({ apps }: ShowcaseSectionProps) {
  return (
    <Section id="apps">
      <Container>
        <h2 className="text-3xl sm:text-4xl font-light tracking-tight text-foreground text-center mb-16">
          Our Apps
        </h2>

        <div className="space-y-24 md:space-y-32">
          {apps.map((app, index) => (
            <AppShowcase
              key={app.id}
              title={app.title}
              description={app.description}
              phoneImage={app.phoneImage}
              privacyPolicyUrl={app.privacyPolicyUrl}
              termsOfServiceUrl={app.termsOfServiceUrl}
              gradientFrom={app.gradientFrom}
              gradientTo={app.gradientTo}
              appStoreUrl={app.appStoreUrl}
              variant={index % 2 === 0 ? "default" : "reversed"}
            />
          ))}
        </div>
      </Container>
    </Section>
  );
}
